<template>
    <v-container>
        <v-row>
            <v-col cols="auto">
                <h2>Jump Links</h2>
            </v-col>
            <v-col>
                <v-btn
                    color="secondary"
                    @click="addJumpLink"
                    class="mr-2"
                >
                    <v-icon>
                        mdi-plus
                    </v-icon>
                </v-btn>
                <v-btn @click="save">save changes</v-btn>
            </v-col>
            <v-col cols="12">
                <v-alert
                    text
                    prominent
                    type="error"
                    v-if="errors.General"
                >
                    {{ errors.General }}
                </v-alert>
            </v-col>
        </v-row>
        <v-row
            class="mb-2"
            v-for="(jumpLink,i) in jumpLinks "
            :key="i"
        >
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="auto">
                            <v-btn
                                small
                                @click="remove(i)"
                                color="secondary"
                            >
                                <v-icon small>
                                    mdi-trash-can
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-text-field
                                v-model="jumpLink.label"
                                label="button label"
                            />
                        </v-col>
                        <v-col cols="auto">
                            <v-autocomplete
                                v-model="jumpLink.location"
                                label="button shows on this page"
                                :items="pages"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <template v-for="(part, index) in jumpLink.parts">
                            <v-col
                                v-if="part.type=='text'"
                                cols="auto"
                                v-bind:key="index"
                            >
                                <v-text-field
                                    name="Name"
                                    v-model="part.value"
                                    type="text"
                                    class="mx-0 px-0"
                                    :error-messages="errors[`JumpLinks[${i}].Parts[${index}].Value`]"
                                >
                                    <template v-slot:append-outer>
                                        <v-icon
                                            color="error"
                                            @click="removePart(jumpLink.parts, index)"
                                        >
                                            mdi-close
                                        </v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col
                                v-else-if="part.type=='dropdown'"
                                cols="auto"
                                v-bind:key="index"
                            >
                                <v-autocomplete
                                    auto-select-first
                                    v-model="part.value"
                                    :items="fields[jumpLink.location]"
                                    item-text="alias"
                                    item-value="name"
                                    class="mx-0 px-0"
                                    :error-messages="errors[`JumpLinks[${i}].Parts[${index}].Value`]"
                                >
                                    <template v-slot:append-outer>
                                        <v-icon
                                            color="error"
                                            @click="removePart(jumpLink.parts, index)"
                                        >
                                            mdi-close
                                        </v-icon>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </template>
                        <v-col
                            cols="auto"
                            class="d-flex align-center"
                        >
                            <v-btn-toggle
                                dense
                                style="gap: 7px"
                            >
                                <v-btn
                                    @click="addText(i)"
                                    color="secondary"
                                >
                                    <v-icon>
                                        mdi-form-textbox
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    @click="addDropdown(i)"
                                    color="secondary"
                                >
                                    <v-icon>
                                        mdi-form-select
                                    </v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-btn
                                class="mr-2"
                                color="secondary"
                            >
                                {{jumpLink.label}}
                            </v-btn>
                            <template v-for="(part, index) in jumpLink.parts">
                                <span
                                    v-if="part.type=='text'"
                                    v-bind:key="index"
                                    style="padding: 0 0px"
                                    v-text="part.value"
                                >
                                </span><span
                                    v-else-if="part.type=='dropdown' && part.value"
                                    class="primary--text"
                                    style="outline: 1px #4e8fca solid;padding:0 3px;margin:0 3px"
                                    v-bind:key="index"
                                    v-text="part.value"
                                >
                                </span>
                            </template>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
import { accountService, jumpLinksService } from '@/services'
import { Page } from '@/types/enums'
import Vue from 'vue'

export default Vue.extend({
    components: {
    },
    data(){
        return {
            fields:{},
            jumpLinks:[],
            errors: {}
        }
    },
    async created() {
        this.fields[Page.PROPERTY_INFORMATION] = await (await accountService.GetPageConfig(Page.PROPERTY)).fields
        this.fields[Page.TENANT] = await (await accountService.GetPageConfig(Page.TENANTS)).fields
        this.jumpLinks = (await jumpLinksService.getJumpLinks())??[]
    },
    methods:{
        addJumpLink() {
            const jumpLink = {
                label:'',
                location:'',
                parts:[{type:'text',value:'https://'}],
            }

            this.jumpLinks.push(jumpLink)
        },
        remove(i){
            this.jumpLinks.splice(i,1)
        },
        addText(i){
            this.jumpLinks[i].parts.push({type:'text',value:''})
        },
        addDropdown(i){
            this.jumpLinks[i].parts.push({type:'dropdown',value:''})
        },
        async save() {
            this.errors = {}
            try {
                await jumpLinksService.saveJumpLinks(this.jumpLinks)
                location.reload()
            } catch (e) {
                if(this.axios.isAxiosError(e) && e?.response?.status == 400 && e.response.data && e.response.data.errors) {
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        this.$set(this.errors, key, value)
                    }
                    this.$set(this.errors, 'General', 'There are errors that require your attention')
                } else {
                    this.$set(this.errors, 'General', 'We\'re sorry, but we can\'t process your request at this time. Please try again later.')
                }
            }
        },
        removePart(parts, index) {
            parts.splice(index,1)
        }
    },
    computed : {
        pages() {
            return [{text:'Property Information',value:Page.PROPERTY_INFORMATION},{text:'Tenant',value:Page.TENANT}]
        }
    }
})
</script>
